import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/assortment/')({
  loader: () => {
    throw redirect({
      to: `/assortment/banners`,
    })
  },
})
